var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    width: 1440,
    height: 560,
    preserveAspectRatio: "none",
    viewBox: "0 0 1440 560",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(\"#SvgjsMask1000\")",
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 560,
    x: 0,
    y: 0,
    fill: "#0e2a47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1309 106L1308 -302",
    strokeWidth: 6,
    stroke: "url(#SvgjsLinearGradient1001)",
    strokeLinecap: "round",
    className: "Down"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437 188L436 458",
    strokeWidth: 6,
    stroke: "url(#SvgjsLinearGradient1001)",
    strokeLinecap: "round",
    className: "Down"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M749 105L748 446",
    strokeWidth: 8,
    stroke: "url(#SvgjsLinearGradient1001)",
    strokeLinecap: "round",
    className: "Down"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226 191L225 13",
    strokeWidth: 6,
    stroke: "url(#SvgjsLinearGradient1001)",
    strokeLinecap: "round",
    className: "Down"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1137 195L1136 -4",
    strokeWidth: 6,
    stroke: "url(#SvgjsLinearGradient1001)",
    strokeLinecap: "round",
    className: "Down"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491 348L490 562",
    strokeWidth: 8,
    stroke: "url(#SvgjsLinearGradient1001)",
    strokeLinecap: "round",
    className: "Down"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M758 445L757 776",
    strokeWidth: 6,
    stroke: "url(#SvgjsLinearGradient1001)",
    strokeLinecap: "round",
    className: "Down"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1298 487L1297 235",
    strokeWidth: 8,
    stroke: "url(#SvgjsLinearGradient1001)",
    strokeLinecap: "round",
    className: "Down"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118 436L117 170",
    strokeWidth: 6,
    stroke: "url(#SvgjsLinearGradient1002)",
    strokeLinecap: "round",
    className: "Up"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M789 223L788 30",
    strokeWidth: 8,
    stroke: "url(#SvgjsLinearGradient1002)",
    strokeLinecap: "round",
    className: "Up"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580 168L579 -152",
    strokeWidth: 10,
    stroke: "url(#SvgjsLinearGradient1002)",
    strokeLinecap: "round",
    className: "Up"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365 75L364 -205",
    strokeWidth: 8,
    stroke: "url(#SvgjsLinearGradient1001)",
    strokeLinecap: "round",
    className: "Down"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1054 343L1053 578",
    strokeWidth: 6,
    stroke: "url(#SvgjsLinearGradient1001)",
    strokeLinecap: "round",
    className: "Down"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1024 312L1023 -34",
    strokeWidth: 8,
    stroke: "url(#SvgjsLinearGradient1002)",
    strokeLinecap: "round",
    className: "Up"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M923 506L922 283",
    strokeWidth: 10,
    stroke: "url(#SvgjsLinearGradient1001)",
    strokeLinecap: "round",
    className: "Down"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1317 526L1316 910",
    strokeWidth: 8,
    stroke: "url(#SvgjsLinearGradient1001)",
    strokeLinecap: "round",
    className: "Down"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1132 43L1131 227",
    strokeWidth: 8,
    stroke: "url(#SvgjsLinearGradient1001)",
    strokeLinecap: "round",
    className: "Down"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1065 309L1064 126",
    strokeWidth: 8,
    stroke: "url(#SvgjsLinearGradient1002)",
    strokeLinecap: "round",
    className: "Up"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M925 20L924 166",
    strokeWidth: 6,
    stroke: "url(#SvgjsLinearGradient1002)",
    strokeLinecap: "round",
    className: "Up"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1415 535L1414 765",
    strokeWidth: 6,
    stroke: "url(#SvgjsLinearGradient1002)",
    strokeLinecap: "round",
    className: "Up"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170 379L169 624",
    strokeWidth: 10,
    stroke: "url(#SvgjsLinearGradient1001)",
    strokeLinecap: "round",
    className: "Down"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629 501L628 651",
    strokeWidth: 8,
    stroke: "url(#SvgjsLinearGradient1001)",
    strokeLinecap: "round",
    className: "Down"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M870 471L869 889",
    strokeWidth: 6,
    stroke: "url(#SvgjsLinearGradient1002)",
    strokeLinecap: "round",
    className: "Up"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M796 296L795 -64",
    strokeWidth: 10,
    stroke: "url(#SvgjsLinearGradient1002)",
    strokeLinecap: "round",
    className: "Up"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391 341L390 695",
    strokeWidth: 8,
    stroke: "url(#SvgjsLinearGradient1001)",
    strokeLinecap: "round",
    className: "Down"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1059 480L1058 899",
    strokeWidth: 6,
    stroke: "url(#SvgjsLinearGradient1001)",
    strokeLinecap: "round",
    className: "Down"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599 95L598 238",
    strokeWidth: 6,
    stroke: "url(#SvgjsLinearGradient1001)",
    strokeLinecap: "round",
    className: "Down"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1174 12L1173 317",
    strokeWidth: 8,
    stroke: "url(#SvgjsLinearGradient1002)",
    strokeLinecap: "round",
    className: "Up"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630 1L629 -290",
    strokeWidth: 8,
    stroke: "url(#SvgjsLinearGradient1002)",
    strokeLinecap: "round",
    className: "Up"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643 301L642 -23",
    strokeWidth: 10,
    stroke: "url(#SvgjsLinearGradient1002)",
    strokeLinecap: "round",
    className: "Up"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M976 497L975 828",
    strokeWidth: 10,
    stroke: "url(#SvgjsLinearGradient1001)",
    strokeLinecap: "round",
    className: "Down"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1360 18L1359 358",
    strokeWidth: 6,
    stroke: "url(#SvgjsLinearGradient1001)",
    strokeLinecap: "round",
    className: "Down"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1380 309L1379 498",
    strokeWidth: 6,
    stroke: "url(#SvgjsLinearGradient1002)",
    strokeLinecap: "round",
    className: "Up"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 347L59 -16",
    strokeWidth: 10,
    stroke: "url(#SvgjsLinearGradient1001)",
    strokeLinecap: "round",
    className: "Down"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42 548L41 736",
    strokeWidth: 6,
    stroke: "url(#SvgjsLinearGradient1002)",
    strokeLinecap: "round",
    className: "Up"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M838 485L837 774",
    strokeWidth: 8,
    stroke: "url(#SvgjsLinearGradient1002)",
    strokeLinecap: "round",
    className: "Up"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "SvgjsMask1000"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 560,
    fill: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%",
    id: "SvgjsLinearGradient1001"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgba(28, 83, 142, 0)",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1c538e",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "0%",
    y2: "0%",
    id: "SvgjsLinearGradient1002"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgba(28, 83, 142, 0)",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1c538e",
    offset: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.9e24b7574f917a7a3378690b231162e1.svg";
export { ForwardRef as ReactComponent };